import { useContext } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { UserContext, UserNameContext } from "../../contexts/user.context";
import SignOut from "../../components/signout/signout.component";
import { ProfileContainer, ProfileCard, Avatar, Name, ButtonGroup, ProfileButton } from "./profile.styles";

const Profile = () => {
  const { currentUser } = useContext(UserContext);
  const { userName } = useContext(UserNameContext);
  const navigate = useNavigate();

  if (!currentUser) {
    return <Navigate to={"../1122111"} replace />;
  }

  const handleViewWebsite = () => {
    const userPath = `/${userName || "defaultUser"}`; // Use the username as path
    window.open(userPath, "_blank"); // Opens in a new tab
  };

  return (
    <ProfileContainer>
      <ProfileCard>
        <Avatar src={currentUser.photoURL || "https://via.placeholder.com/100"} alt="Profile" />
        <Name>{currentUser.displayName || "No Name"} (@{userName || "Username"})</Name>
        <ButtonGroup>
          <ProfileButton onClick={handleViewWebsite}>View Website</ProfileButton>
          <ProfileButton onClick={() => navigate(`/customize`)}>Customize Website</ProfileButton>
        </ButtonGroup>
        <SignOut />
      </ProfileCard>
    </ProfileContainer>
  );
};

export default Profile;
